import { Backdrop, CircularProgress } from '@mui/material';

import { LoaderProps } from './types';

export const Loader = ({
  children,
  isLoading = false,
  fullScreen = true,
  absolutePosition = false,
}: LoaderProps) => {
  const backdropProps = {
    sx: {
      top: 0,
      left: 0,
      zIndex: 2000,
      backdropFilter: 'blur(3px)',
      width: `100${fullScreen ? 'vw' : '%'}`,
      height: `100${fullScreen ? 'vh' : '%'}`,
      bgcolor: fullScreen ? 'rgba(255, 255, 255, 0.95)' : 'transparent',
      position: fullScreen
        ? 'fixed'
        : absolutePosition
          ? 'absolute'
          : 'relative',
    },
  };

  return (
    <>
      {children}
      <Backdrop open={isLoading} {...backdropProps}>
        {isLoading && <CircularProgress size={80} />}
      </Backdrop>
    </>
  );
};
